﻿'use strict';

angular.module('ntmApp').factory('FindStaffFilter', ['SimpleFilter', 'WeeklyHoursFilter', 'WeeklyDaysFilter', 'RadioButtonChoiceFilter', 'SplitHM', function (SimpleFilter, WeeklyHoursFilter, WeeklyDaysFilter, RadioButtonChoiceFilter, SplitHM) {

    function FindStaffFilter() {

        var self = this;

        self.FacilityFilter = new SimpleFilter();
        self.AvailableHours = new SplitHM('Duration {0}h {1}m');
        self.HasApprovedOvertime = new RadioButtonChoiceFilter(function (item) {

            if (item === 'yes') {
                return 'Has approved overtime this week';
            }

            if (item === 'no') {
                return 'Does not have approved overtime this week';
            }

            return '';
        });
        self.SkillSet = new SimpleFilter();
        self.SpecificDays = new WeeklyDaysFilter();

        self.getfilters = function () {
            return [
                self.FacilityFilter,
                self.AvailableHours,
                self.HasApprovedOvertime,
                self.SkillSet,
                self.SpecificDays
            ];
        };

        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function (filter) { return filter.isPartlyDefined(); });
        };

        self.isDefined = function () {
            return self.getfilters().some(function (filter) { return filter.isDefined(); });
        };

        self.clearAllFilters = function () {
            self.getfilters().forEach(function (filter) {
                filter.clear();
            });
        };

        self.performFiltering = function (staffList) {

            var result = [];

            if (staffList) {
                staffList.forEach(function (staff) {

                    var filteredItems = filterGroupItems(staff);

                    result = result.concat(filteredItems);

                });
            }

            return result;

        };

        function filterGroupItems(staff) {

            var filteredStaff = angular.copy(staff);
            filteredStaff.days = [];

            if (staff.days) {
                staff.days.forEach(function (item) {

                    if (self.FacilityFilter.isDefined() && !staff.staffSetupFacilities.some(function (facility) { return facility.id === self.FacilityFilter.filterItem.id;})) {
                        return [];
                    }

                    if (self.AvailableHours.isDefined() && (self.AvailableHours.hours ? self.AvailableHours.hours : 0) * 60 + (self.AvailableHours.minutes || 0) > item.available * 60) {
                        return [];
                    }

                    if (self.HasApprovedOvertime.isDefined() && (self.HasApprovedOvertime.filterItem === 'yes' && item.overtime === 0 || self.HasApprovedOvertime.filterItem === 'no' && item.overtime > 0)) {
                        return [];
                    }

                    if (self.SkillSet.isDefined() && !checkSkillsForStaff(filteredStaff)) {
                        return [];
                    }

                    if (self.SpecificDays.isDefined() && !self.SpecificDays.selectedDays.some(function (day) { return day.label === item.dayLabel; })) {
                        return [];
                    }

                    filteredStaff.days.push(item);

                });
            }

            return filteredStaff.days.length > 0 ? filteredStaff : [];
        }

        function checkSkillsForStaff(staff) {
            if (!staff.staffSkills) {
                return false;
            }

            var result = false;
            staff.skillsCount = 0;

            self.SkillSet.filterItem.activities.forEach(function (skill) {

                var hasSkills = staff.staffSkills.some(function (staffSkill) {
                    if (staffSkill.activitiId === skill.id && checkSpecies(staffSkill.species)) {
                        staff.skillsCount += 1;
                        return true;
                    } else {
                        return false;
                    }
                });

                if (hasSkills) {
                    result = true;
                }
            });

            return result;
        }

        function checkSpecies(staffSpecies) {
            if (!self.SkillSet.filterItem.skillSetSpecies) {
                return true;
            }

            if (!staffSpecies) {
                return false;
            }

            var skillSpecies = self.SkillSet.filterItem.skillSetSpecies.split(';');

            staffSpecies = staffSpecies.split(';');

            return skillSpecies.every(function (species) {
                return staffSpecies.some(function (sp) {
                    return species === sp;
                });
            });
        }
    }

    return (FindStaffFilter);
}]);